import React from 'react'
import MiniLayout from '../components/MiniLayout'

const AdminOrders = () => {
  return (
    <MiniLayout>
        <div className="adminOrders">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. A assumenda consectetur placeat alias facere obcaecati ex magni commodi in, dolor ut dolorem voluptas quod, voluptatem iure! Aspernatur quas fuga recusandae.
        </div>
    </MiniLayout>
  )
}

export default AdminOrders